module.exports = __webpack_public_path__ + "static/media/ts9tj0.c95bc960.png";